//const API_BASE = "http://10.8.24.133:2127/api";
//const API_BASE = "http://10.8.26.47:2127/api";
const API_BASE = "/api";
//const API_BASE = "https://localhost:7207/api";

export const RUTAS_USER = {
  GET_ROLES: `${API_BASE}/Account/GetRoles`,
  GET_USERS: `${API_BASE}/Account/GetUsers`,
  GET_USERBYID: id => `${API_BASE}/Account/GetUserById?idUser=${id}`,
  VALID_USER: `${API_BASE}/Account/ValidarCodigoInt`,
  CREATE_USER: `${API_BASE}/Account/RegisterUser`,
  REGISTER_USER_OFICE: `${API_BASE}/Account/RegisterUserOffice`,
  UPDATE_USER: `${API_BASE}/Account/UpdateUser`,
};

export const RUTAS_LOGIN = {
  GET_PASS: `${API_BASE}/Login/ForgetPassword`,
  UPDATE_PASS: `${API_BASE}/Login/UpdatePassword`,
  SINGIN: `${API_BASE}/Login/SingIn`,
};

export const RUTAS_BITACORAS = {
    GET_OFICINAS: (id, rol) =>  `${API_BASE}/Bitacora/GetOficinasByUser?idUser=${id}&rol=${rol}`,
    GET_AGENTES: `${API_BASE}/Bitacora/GetAgentes`,
    GET_PROMOTORES: `${API_BASE}/Bitacora/GetPromotores`,
    GET_TIPOCONTACTO: `${API_BASE}/Bitacora/GetTipoContacto`,
    GET_ACTIVIDADES: `${API_BASE}/Bitacora/GetActividades`,
    GET_ACUERDOVISITA: `${API_BASE}/Bitacora/GetAcuerdosVisita`,
    GET_DURACIONES: `${API_BASE}/Bitacora/GetDuracion`,
    REGISTER_BITACORA: `${API_BASE}/Bitacora/RegisterBitacora`,
    GET_BITACORA: id => `${API_BASE}/Bitacora/GetBitacoras?usuario=${id}`,
    GET_BITACORAID: id => `${API_BASE}/Bitacora/GetBitacoraById?idBitacora=${id}`,
    UPDATE_ACUERDO_BITACORA: `${API_BASE}/Bitacora/UpdateAcuerdoBitacora`,
    GET_BITACORA_JEFE_EXCEL: (usuario, fecha_ini, fecha_fin) => `${API_BASE}/Bitacora/GetBitacorasJefe?usuario=${usuario}&fecha_ini=${fecha_ini}&fecha_fin=${fecha_fin}`,
};
export const RUTAS_INCIDENCIAS = {
    GET_TIPO_INCIDENCIA: `${API_BASE}/Incidencia/GetTipoIncidencia`,
    GET_EMPLEADOS: id => `${API_BASE}/Incidencia/GetEquipo?usuario=${id}`,
    REGISTER_INICIDENCIA: `${API_BASE}/Incidencia/RegisterIncidencia`,
    GET_INCIDENCIAS: id => `${API_BASE}/Incidencia/GetIncidencias?usuario=${id}`,
    GET_INCIDENCIAID: id => `${API_BASE}/Incidencia/GetIncidenciaByID?idIncidencia=${id}`,
    UPDATE_INCIDENCIA: `${API_BASE}/Incidencia/UpdateIncidencia`,
    GET_INCIDENCIA_JEFE_EXCEL: (usuario, fecha_ini, fecha_fin) => `${API_BASE}/Incidencia/GetIncidenciasJefe?usuario=${usuario}&fecha_ini=${fecha_ini}&fecha_fin=${fecha_fin}`,
};